module.exports = __webpack_public_path__ + "static/media/22ESCWA10.6bfe9102.jpg";